import type {ReactNode} from "react";
import type {LinkedContractDocument} from "pay/checkoutDocument";
import {advertisingTermsLink} from "./advertisingTermsDocument";
import {TermsDocumentLink, TermsLink} from "./SponsorPage.styles";

/**
 * The link inside the acceptance sentence (kitecorp/transferify-api-service#2149): the immutable registered
 * document the api announced, opened in a new tab so the half-filled form underneath is not lost, or the
 * `/advertising-terms` page when the api announced none. Which of the two is `advertisingTermsLink`'s
 * decision; this only renders it.
 */
export function AdvertisingTermsLink({document, children}: {document: LinkedContractDocument | null; children: ReactNode}) {
	const target = advertisingTermsLink(document);
	if (target.immutable && document) {
		return <TermsDocumentLink href={target.href} lang={document.identity.locale} type={document.contentType}
			target="_blank" rel="noopener noreferrer">
			{children}
		</TermsDocumentLink>;
	}
	return <TermsLink to={target.href} target="_blank" rel="noopener">{children}</TermsLink>;
}
